import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { FilterCalendarIcon } from '../../assets';
import { useFilterContext } from '../../contexts/FiltersContext';
import { YearFilter } from '../../models/Filter';
import BaseFilterComponent from './BaseFilterComponent';
import { StyledButton, StyledSecondaryButton } from './FiltersList.styles';
import { useRangeFilter } from './hooks/RangeFilter';
import RangeFilter from './RangeFilter';
import { InputType } from './RangeFilter/RangeFilter';
import { FilterFooterMobile } from './shared/FilterFooterMobile.styles';

export const AddYearFilterComponent = () => {
  const { t } = useTranslation();
  const min = 1990;
  const max = 2023;
  const { handleApplyFilter, setOpenFiltersMobile, setSelectedFilterTitle, getSelectedFilter, handleRemoveFilter } =
    useFilterContext();

  const filter = getSelectedFilter(YearFilter) as YearFilter;

  const { getFilter, onRangeChange, range } = useRangeFilter({
    min,
    max,
    filter,
    constructor: (start, end) => new YearFilter({ start, end }),
  });

  const applyOnClick = () => {
    if (!getFilter) return;
    const filter = getFilter();
    handleApplyFilter(filter);
    setTimeout(() => {
      setOpenFiltersMobile(false);
      setSelectedFilterTitle('');
    }, 100);
  };

  const removeYearFilter = () => {
    handleRemoveFilter(filter);
    setTimeout(() => {
      setOpenFiltersMobile(false);
      setSelectedFilterTitle('');
    }, 100);
  };

  return (
    <>
      <RangeFilter
        stepValue={1}
        minValue={min}
        maxValue={max}
        values={range}
        inputType={InputType.Year}
        handleChange={onRangeChange}
      />
      <FilterFooterMobile>
        <StyledSecondaryButton onPress={removeYearFilter}>{t('filters.clearAll')}</StyledSecondaryButton>
        <StyledButton onPress={applyOnClick}>{t('filters.applyFilter')}</StyledButton>
      </FilterFooterMobile>
    </>
  );
};

const AddYearFilter = () => {
  const min = 1990;
  const max = 2023;
  const { getSelectedFilter } = useFilterContext();

  const filter = getSelectedFilter(YearFilter) as YearFilter;

  const { getFilter, onRangeChange, range, onCancel } = useRangeFilter({
    min,
    max,
    filter,
    constructor: (start, end) => new YearFilter({ start, end }),
  });
  const { t } = useTranslation();

  return (
    <BaseFilterComponent
      getFilter={getFilter}
      icon={<FilterCalendarIcon />}
      title={t('filters.year')}
      onCancel={onCancel}
      inUse={!!filter}
      storedFilter={filter}
    >
      <RangeFilter
        stepValue={1}
        minValue={min}
        maxValue={max}
        values={range}
        inputType={InputType.Year}
        handleChange={onRangeChange}
      />
    </BaseFilterComponent>
  );
};

export default AddYearFilter;
